import React from "react";
import { ChevronLeftIcon } from "../../../../helper/HwIcon";

const PassengerPageHeader = ({ currentTab, headerBackButtonFn }) => {
    const tab1Active = currentTab?.["1"]?.active;
    const tab2Active = currentTab?.["2"]?.active;

    if (!tab1Active && !tab2Active) return null;

    return (
        <div className="hw-passenger--head">
            <h2 className="mb-0 hw-blue h3">
                Complete Your Booking
            </h2>

            <div className="d-flex align-items-center hw-gapy10">
                <button
                    onClick={headerBackButtonFn}
                    className="hw-link hw-link--gray700 hw-link--icon"
                >
                    <ChevronLeftIcon />
                    {tab1Active ? "Back to Search" : "Back"}
                </button>
            </div>
        </div>
    );
};

export default React.memo(PassengerPageHeader);